export const matchMenu = (path, roleMenus) => {
    while (path.length > 1 && path.endsWith("/")) {
        path = path.substring(0, path.length - 1);
    }
    const matchRoleMenus = [];
    for (let i = 0; i < (roleMenus?.length || 0); ++i) {
        const roleMenu = roleMenus[i];
        const menuUrl = roleMenu.refMenu.url;
        const matcher = new RegExp(menuUrl, "i");
        if (matcher.test(path)) {
            matchRoleMenus.push(roleMenu);
        }
    }
    if (matchRoleMenus.length > 0) {
        const roleMenu = matchRoleMenus[0];
        let attribute = roleMenu.attribute;
        if (!attribute) {
            attribute = [];
            roleMenu.attribute = attribute;
        }
        for (let i = 1; i < matchRoleMenus.length; ++i) {
            const rm = matchRoleMenus[i];
            const rmAttribute = rm.attribute;
            if (rmAttribute) {
                roleMenu.attribute.push(...rmAttribute);
            }
        }
        roleMenu.attribute = [...new Set(roleMenu.attribute)];
        return roleMenu;
    }
    return null;
};

export const has = ({ menuContext, key, value }) => {
    return menuContext?.attribute?.includes(key) || menuContext?.query?.[key] ? menuContext?.query?.[key] === value : false;
};

export const have = ({ menuContext, keys = [], key, value }) => {
    const keyList = key || keys;
    for (const index in keyList) {
        const key = keyList[index];
        if (has({ menuContext, key, value })) {
            return true;
        }
    }
};
